var map = {
	"./download.svg": "039a",
	"./fileText.svg": "34ef",
	"./filegykj.svg": "6373",
	"./filekj.svg": "8c7a",
	"./filektz.svg": "1d5a",
	"./files.svg": "a10d",
	"./new.svg": "11d9",
	"./pic.svg": "079e",
	"./tips.svg": "a994"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";